import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AccountAuthService } from './account-auth.service';

export const accountAuthGuard: CanActivateFn = () => {
  const auth = inject(AccountAuthService);
  const router = inject(Router);
  const loginTree = router.createUrlTree(['/login']);

  if (!auth.isAuthenticated()) {
    return loginTree;
  }

  return auth.refreshAccess().pipe(
    map(() => true),
    catchError(() => of(loginTree))
  );
};
